'use client';

import { createContext, ReactNode, useContext } from 'react';

const HostContext = createContext<string | undefined>(undefined);

export function HostProvider({ host, children }: { host: string; children: ReactNode }) {
  return <HostContext.Provider value={host}>{children}</HostContext.Provider>;
}

export function useHost() {
  const context = useContext(HostContext);
  if (!context) {
    throw new Error('useHost must be used within a HostProvider');
  }
  return context;
}
